import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW4002Component } from './kymw4002.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { DeletePromotionListService } from './api-services/delete-promotion-list.service';
import { RegistPromotionListService } from './api-services/regist-promotion-list.service';
import { UpdatetPromotionListService } from './api-services/update-promotion-list.service';

/**
 * プロモーションマスタメンテナンス画面 モジュール設定クラス
 *
 * @export KYMW4002Module
 * @class KYMW4002Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW4002Component,
  ],
  providers: [
    DeletePromotionListService,
    RegistPromotionListService,
    UpdatetPromotionListService,
  ],
})

export class KYMW4002Module { }
